import intl from 'react-intl-universal';

export function validate(email: string, setError: (error: string) => void) {
  if (!/^(.+@.+\.[a-zA-Z]+)$/.test(email)) {
    setError(intl.get('validation.email.validEmailError'));
    return false;
  }
  setError('');
  return true;
}
